import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { Controller } from '@/types/controller'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchController(
  searchParams: SearchParams = {},
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<Controller>, any> {
  return useQuery(
    [queryKeys.controller, interfaceId, searchParams],
    async () => {
      const { data } = await controllerDataConfigApi.getAll({
        interfaceId,
        ...searchParams,
      })

      if (!data) return null

      const controllerList =
        data.data.length > 0 &&
        data?.data.map((item: any) => {
          return {
            id: item.id,
            name: item.name,
            address: item.address,
            index: item.index,
            decoderType: item.decoderType,
            type: item.type,
            configuration: item.configuration,
            configState: item.configState,
            attention: item.attention,
            value: item.value,
            configurationId: item.configurationId,
            decoderId: item.decoderId,
            typeId: item.typeId,
            discoverState: item.discoverState,
            verifySum: item.verifySum,
            twiId: item.twiId,
            twiCustomName: item.twiCustomName,
            twiOriginalId: item.twiOriginalId,
          }
        })
      return {
        list: controllerList,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchController
